import { FC } from "react"
import { useTranslation } from "react-i18next"
import { ErrorView } from "./ErrorView"
import { getProductName } from "@/utils/product-name"

export const WebGLUnavailableErrorView: FC<{ api?: "webgl2" }> = ({ api }) => {
	const { t } = useTranslation("components")
	const name = api === "webgl2" ? "WebGL2" : "WebGL"

	return (
		<ErrorView
			title={t("webGLUnavailableErrorView.isNotAvailable", { name: name })}
			description={t("webGLUnavailableErrorView.requiresToFunction", {
				var0: getProductName(),
				name: name,
			})}
			action={
				<a
					className="electron-no-drag hidden text-sm text-accent-500 hover:opacity-50 sm:block"
					href="https://get.webgl.org/"
					target="_blank"
					rel="noreferrer"
				>
					{t("webGLUnavailableErrorView.checkWebGL")}
				</a>
			}
		/>
	)
}
